/* global React */
import { useMemoRef, useStyles } from '@platform/react/hook'
import { Grid, useTheme } from '@mui/material'
import useCart from 'platform/react/hook/useCart'
import { cloneElement, useEffect, useState } from 'react'
import { arrayOf } from 'lib/util'

/**
 * CartSteps component
 *
 * @param {Object} cart             the currently active cart
 * @param {React.Ref} forwardedRef  forwarded ref
 * @param {Object} parentClasses    classes injected from the parent
 * @param {number} activeStep       the currently active step
 * @param {Object} props            additional props
 * @returns {JSX.Element}
 */
const CartSteps = ({
  forwardedRef,
  cart: initialCart,
  classes: parentClasses,
  activeStep,
  children,
  ...props
}) => {
  const theme = useTheme()
  const { spacing = 0, space = 0, gap = 0 } = props

  const { cart: currentCart } = useCart()
  const [cart, setCart] = useState(initialCart)
  useEffect(() => { setCart(currentCart) }, [currentCart])

  return (
    <Grid
      item
      container
      ref={forwardedRef}
      xs={props.xs}
      sm={props.sm}
      md={props.md}
      lg={props.lg}
      xl={props.xl}
      style={{
        padding: spacing
          ? theme.spacing(spacing)
          : theme.spacing(space, gap),
      }}
    >
      {!cart ? null
        : arrayOf(children).map((child, i) => (
          i !== activeStep ? null : cloneElement(child, {
            update: props.update,
          })
        ))
      }
    </Grid>
  )
}

export default useMemoRef(CartSteps, false)
